import Vue from "vue";
import axios from "axios";
import router from "@/router";
import qs from "qs";
import merge from "lodash/merge";
import { MessageBox, Message } from "element-ui";
import { clearLoginInfo } from "@/utils";
let tokenAbnormal = false;

const http = axios.create({
  baseURL: window.SITE_CONFIG.baseUrl,
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  (config) => {
    //  如果存在 token 则附带在 http header 中
    if (Vue.cookie.get("X-Admin-Token")) {
      config.headers["X-Admin-Token"] = Vue.cookie.get("X-Admin-Token"); // 请求头带上token
    }
    if (config.method == "get") {
      config.params = {
        t: new Date().getTime(),
        ...config.params,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function fn(callback) {
  fn.prototype.init(callback);
}
fn.prototype = {
  canclick: true,
  init: function (callback) {
    if (this.canclick) {
      this.canclick = false;
      callback();
      setTimeout(
        function () {
          this.canclick = true;
        }.bind(this),
        5000
      );
    } else {
      console.log("1s中之内不允许重复点击");
    }
  },
};

/**
 * 响应拦截
 */
http.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 3 * 1000,
      });
      // 判断 token 失效的场景
      if (res.code === 501 && !tokenAbnormal) {
        // 如果 token 失效，则弹出确认对话框，用户点击后，清空 token 并返回登录页面
        tokenAbnormal = true;
        MessageBox.confirm("页面失效是否重新登录！", {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            clearLoginInfo();
            // 设置定时器，确保下次异常时弹出框正常弹出
            setTimeout(() => {
              tokenAbnormal = false;
            }, 100);
            router.push({ name: "login" });
          })
          .catch(() => {
            tokenAbnormal = false;
          });
      }
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return response;
    }
  },
  (error) => {
    let err = JSON.parse(JSON.stringify(error)),
      message = err.message || `接口${err.status}错误`;
    if (!error.code) {
      message = "服务正在启动中，请稍后再试!";
    } else {
      message = err.message || `接口${err.status}错误`;
    }

    if (error.config.url.indexOf("api/order/searchEntrustPdf") > -1) {
      // 针对生成接口，修改提示
      message = "生成中，清稍后再试";
    }

    fn(function () {
      Message({
        message: message,
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(error);
    });
  }
);

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    t: new Date().getTime(),
  };
  return openDefultParams ? merge(defaults, params) : params;
};

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = "json") => {
  var defaults = {
    t: new Date().getTime(),
  };
  data = openDefultdata ? merge(defaults, data) : data;
  return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
};

export default http;